import { post, get } from "../httpmethods";
import { put } from "../httpmethods";
import { URL_API } from "../config";


export const CompanyServicesAPI = {
    createService: async (body) => {
        return await post(`${URL_API}/company/service`, body);
    },
    getServices: async (data) => {
        return await get(`${URL_API}/company/service`, data);
    },

    updateService: async (body) => {
        return await put(`${URL_API}/company/service`, body);
    },

    deleteService: async (body) => {
        return await post(`${URL_API}/company/service/delete`, body);
    }
}